import axios from "axios";
import config from "@/config";

const AUTO_CITY_ID_EXCEPTIONS = [
    '/index.php?route=api/location/polygons',
    '/index.php?route=api/order/historyv2'
]

function createAPI(store, router) {
    const axiosConfig = {
        baseURL: config.hostname,
        withCredentials: true,
    };

    const API = axios.create(axiosConfig);

    API.interceptors.request.use(
        function (config) {
            if (store?.state?.city?.city_id && !AUTO_CITY_ID_EXCEPTIONS.includes(config.url) && (!config.params || !config.params.store_id)) {
                if (!config.params) {
                    config.params = {};
                }

                config.params = { ...config.params, store_id: config.params?.store_id ?? store.state.city.city_id };
            }

            return config;
        },
        error => Promise.reject(error)
    );


    API.interceptors.response.use(
        function (response) {
            return response.data;
        },
        function (error) {
            const errors = {};
            if (!error.response) {
                // No response received, handle the error here (e.g., show an error message)
                errors['system'] = 'Ответ от сервера не получен. Пожалуйста повторите запрос. Возможно проблема в соединении с интернетом'
                return Promise.reject(error);
            }

            const { status } = error.response;

            if (status === 401) {
                store.commit('user/setUser', null);
                store.commit('setShowLoginModal', true);
                return Promise.reject(error);
            }

            if (status === 403) {
                store.commit('setShowLoginModal', false);
                return Promise.reject(error);
            }

            // if (status === 404) {
            //     router.push({ name: '404'});
            //     error.code = status;
            //     return Promise.reject(error);
            // }

            if (status === 473) {
                store.commit('setStopListModal', true);
                return Promise.reject(error);
            }

            return Promise.reject(error);
        }
    );

    return API; // Возвращаем существующий или только что созданный экземпляр Axios
}

class AXIOS_INTERCEPTORS {
    constructor(store, router) {
        this.store = store;
        this.router = router;
    }

    create() {
        return createAPI(this.store, this.router);
    }
}

export default AXIOS_INTERCEPTORS;
